import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const authors = `${REACT_APP_API_PREFIX}/${service}/authors`;

export function getAuthors(filters) {
  const url = `${authors}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getAuthorById(id) {
  const url = `${authors}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateAuthor(id, body) {
  const url = `${authors}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteAuthor(id) {
  const url = `${authors}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createAuthor(body) {
  const url = `${authors}`;
  return {
    method: POST,
    url,
    body,
  };
}
